import styles from './PageHeader.module.css'

/**
 * Editorial page header: uppercase eyebrow, serif display title, and a lead
 * paragraph, closed by a hairline rule with a brass tick. Used by every module.
 */
export default function PageHeader({ eyebrow, title, lead, actions }) {
  return (
    <header className={`${styles.header} fade-up`}>
      <div className={styles.row}>
        <div className={styles.text}>
          {eyebrow && <div className="eyebrow">{eyebrow}</div>}
          <h1 className={`${styles.title} display`}>{title}</h1>
          {lead && <p className={styles.lead}>{lead}</p>}
        </div>
        {actions && <div className={styles.actions}>{actions}</div>}
      </div>
      <hr className="rule" />
    </header>
  )
}
